import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import { Tooltip, Popconfirm } from "antd";
import "./ActionIcon.scss";

const ActionIcon = forwardRef(({
  title,
  icon,
  onClick,
  disabled = false,
  placement = "top",
  className = "",
  confirm, // { enabled, title, okText, cancelText, onConfirm }
  ...rest
}, ref) => {
  const button = (
    <Tooltip title={title} placement={placement}>
      <button
        ref={ref}
        type="button"
        className={`action-icon ${disabled ? "is-disabled" : ""} ${className}`}
        onClick={disabled ? undefined : onClick}
        disabled={disabled}
        aria-label={title}
        {...rest}
      >
        {icon}
      </button>
    </Tooltip>
  );

  if (confirm?.enabled) {
    return (
      <Popconfirm
        title={confirm.title || "Are you sure?"}
        okText={confirm.okText || "Yes"}
        cancelText={confirm.cancelText || "No"}
        onConfirm={confirm.onConfirm}
        disabled={disabled}
      >
        {button}
      </Popconfirm>
    );
  }

  return button;
});

ActionIcon.displayName = "ActionIcon";

ActionIcon.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  placement: PropTypes.string,
  className: PropTypes.string,
  confirm: PropTypes.shape({
    enabled: PropTypes.bool,
    title: PropTypes.string,
    okText: PropTypes.string,
    cancelText: PropTypes.string,
    onConfirm: PropTypes.func,
  }),
};

export default ActionIcon;
